import { render, staticRenderFns } from "./FeatureSub.vue?vue&type=template&id=7febc126&scoped=true&"
import script from "./FeatureSub.vue?vue&type=script&lang=js&"
export * from "./FeatureSub.vue?vue&type=script&lang=js&"
import style0 from "./FeatureSub.vue?vue&type=style&index=0&id=7febc126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7febc126",
  null
  
)

export default component.exports